/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Not_FoundInputs */

const en_company_profile_not_found = /** @type {(inputs: Company_Profile_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No company profile found.`)
};

const de_company_profile_not_found = /** @type {(inputs: Company_Profile_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Unternehmensprofil gefunden.`)
};

/**
* | output |
* | --- |
* | "No company profile found." |
*
* @param {Company_Profile_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_not_found = /** @type {((inputs?: Company_Profile_Not_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Not_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_not_found(inputs)
	return en_company_profile_not_found(inputs)
});